import { pageHasAppliedPageImage } from './comicPageImageStatus'
import { getPageLayoutOption } from './comicPageLayout'
import { pageHasGeneratableScript } from './comicPagePrompt'
import { getPanelsOnPage } from './comicPages'
import type { ComicEpisode, ComicPage, ComicPageImageStatus } from './comicTypes'

export type EpisodeGeneratePagePickRow = {
  pageId: string
  title: string
  selectable: boolean
  /** 副文案：版式与分镜描述概况 */
  detail: string
  /** 有画面描述时展示整页成图状态角标 */
  pageImageStatus: ComicPageImageStatus | undefined
  hasAppliedImage: boolean
}

export function listEpisodeGeneratePagePickRows(episode: ComicEpisode): EpisodeGeneratePagePickRow[] {
  return episode.pages.map((page) => describeEpisodeGeneratePagePickRow(episode, page))
}

function describeEpisodeGeneratePagePickRow(
  episode: ComicEpisode,
  page: ComicPage,
): EpisodeGeneratePagePickRow {
  const panels = getPanelsOnPage(episode, page)
  const scriptCount = panels.filter((p) => p.script.trim().length > 0).length
  const hasScript = pageHasGeneratableScript(panels)
  const layoutLabel = getPageLayoutOption(page.layout).label
  const detail = `${layoutLabel} · ${panels.length} 格 · ${scriptCount} 格有画面描述`

  const selectable = hasScript && page.pageImageStatus !== 'generating'

  return {
    pageId: page.id,
    title: page.title.trim() || '未命名页',
    selectable,
    detail,
    pageImageStatus: hasScript ? page.pageImageStatus ?? 'draft' : undefined,
    hasAppliedImage: pageHasAppliedPageImage(page),
  }
}

/** 按用户勾选顺序还原 {@link ComicPage} 列表（保持话内分页顺序） */
export function resolveEpisodePagesForGenerate(
  episode: ComicEpisode,
  selectedPageIds: readonly string[],
): ComicPage[] {
  const idSet = new Set(selectedPageIds)
  return episode.pages.filter((p) => idSet.has(p.id))
}

export function selectablePagePickRows(rows: EpisodeGeneratePagePickRow[]): EpisodeGeneratePagePickRow[] {
  return rows.filter((r) => r.selectable)
}
